/**
 * Helper for polyfilling missing APIs before running a function
 * from polyfill.io
 * @module lib/polyfill
 */

// https://philipwalton.com/articles/loading-polyfills-only-when-needed/
/**
 * Loads script at given `src`, calling the `done` callback when loaded
 * or an error occured
 * @param {String} src The URL of the script to load
 * @param {Function} done The callback to run once the script is loaded or errors.
 */
function loadScript(src, done) {
  var js = document.createElement('script');
  js.src = src;
  js.onload = function() {
    done();
  };
  js.onerror = function() {
    done(new Error('Failed to load script ' + src));
  };
  document.head.appendChild(js);
}

/**
 * Checks if all required features are supported by the browser
 */
function supportsAllFeatures() {
  return (
    // https://github.com/Financial-Times/polyfill-library/blob/master/polyfills/Array/from/detect.js
    'from' in Array &&
    (function() {
      try {
        Array.from({ length: -Infinity });

        return true;
      } catch (e) {
        return false;
      }
    })() &&
    'finally' in Promise.prototype &&
    'matches' in Element.prototype &&
    'closest' in Element.prototype
  );
}

// TODO: Check why this would be exported to window
window.supportsAllFeatures = supportsAllFeatures;

// TODO: Review polyfilling
const POLYFILL_URL =
  'https://polyfill.io/v3/polyfill.min.js?flags=gated&features=Array.from%2CPromise.prototype.finally%2CElement.prototype.matches%2CElement.prototype.closest%2CObject.assign%2CPromise%2CURL%2CObject.entries';

/**
 * Runs the provided function immediately if all features are supported
 * or after polyfills have loaded if some APIs need filling
 * @param {Function} done
 */
export default function withPolyfill(done) {
  if (supportsAllFeatures()) {
    done();
  } else {
    loadScript(POLYFILL_URL, done);
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/polyfill.js